import React from 'react';
import NocNavBar from '../../../../layouts/noc/NocNavBar';
import useCheckTwoDepartments from '../../../../../hooks/shared/custom/check-department/useCheckTwoDepartments';
import { NOC, SUPER_ADMIN } from '../../../../../utils/departments/helpers';
import { useUser } from '../../../../../hooks/shared/user/useUser';
import RetrievalBody from '../../../shared/retrievals/RetrievalBody';
import { VICE_PRESIDENT_FSE } from '../../../../../utils/config';

const NocRetrievals = ({ history }) => {
  useCheckTwoDepartments(`${NOC}`, `${VICE_PRESIDENT_FSE}`, `${SUPER_ADMIN}`, history);
  const {
    profile: { firstName },
  } = useUser();

  return (
    <div className="s-layout">
      <main className="s-layout__content col-lg-10 p-0">
        <NocNavBar currentPage="Retrievals" position={firstName} />
        <RetrievalBody />
      </main>
    </div>
  );
};

export default NocRetrievals;
